export default {
  DEFAULT: 'DEFAULT',
  EPISODE: 'EPISODE',
  LIVE: 'LIVE',
  LOGO: 'LOGO',
  HERO_SLIDER: 'HERO',
  HERO_MULTIPLE: 'HERO_MULTIPLE',
  TRAILER: 'TRAILER',
};
